import { render, staticRenderFns } from "./caseDetails.vue?vue&type=template&id=214786d2&scoped=true"
import script from "./caseDetails.vue?vue&type=script&lang=js"
export * from "./caseDetails.vue?vue&type=script&lang=js"
import style0 from "./caseDetails.vue?vue&type=style&index=0&id=214786d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214786d2",
  null
  
)

export default component.exports